import { Observable, Observer } from 'rxjs';
import { getBase64Image } from './getBase64Image';

export function getBase64ImageFromURL(url: string): Observable<string> {
  return new Observable(observer => {
    // create an image object
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    if (!img.complete) {
      // This will call another method that will create image from url
      img.onload = () => {
        observer.next(getBase64Image(img));
        observer.complete();
      };
      img.onerror = err => {
        observer.error(err);
      };
    } else {
      observer.next(getBase64Image(img));
      observer.complete();
    }
  });
}
